import * as React from 'react';
const { useCallback, forwardRef } = React;

import TextField, { TextFieldProps } from '../text-field';
import { formatStrAsNumber } from '../../utils/number';


export type NumberTextFieldProps = {
	ref?: any;
	max?: number;
	precision?: number;
} & TextFieldProps;

const NumberTextField: React.SFC<NumberTextFieldProps> = forwardRef<any, NumberTextFieldProps>((props, ref) => {
	const {
		max,
		precision,
		onChange,
		...rest
	} = props;

	const handleChange = useCallback((e: React.SyntheticEvent<HTMLInputElement>, value: string) => {
		const formattedValue = formatStrAsNumber(value, precision);

		if (max && parseFloat(formattedValue) > max) return;

		onChange(e, formattedValue);
	}, [max, precision, onChange]);

	return (
		<TextField
			{...rest}
			ref={ref}
			onChange={handleChange}
		/>
	);
});

NumberTextField.displayName = 'NumberTextField';
NumberTextField.defaultProps = {};


export default NumberTextField;
